import { render, staticRenderFns } from "./LisaaKoulutus.vue?vue&type=template&id=23f183be&"
import script from "./LisaaKoulutus.vue?vue&type=script&lang=js&"
export * from "./LisaaKoulutus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports